<template>
  <component
    :is="componentName"
    v-bind="attrsWithoutClass"
    :class="
      twMerge(
        'inline-flex cursor-pointer items-center justify-center font-medium transition-all outline-none select-none hover:[box-shadow:none] hover:shadow-transparent focus:outline-none disabled:cursor-not-allowed',
        `${color}-button`,
        sizes[size],
        isBlock ? 'w-full' : '',
        isRounded ? 'rounded-full' : '',
        attrs.class as string,
      )
    "
    :disabled="isDisabled"
    :href="href && !isDisabled ? href : false"
    :test_id="attrs.test_id"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import { computed, useAttrs } from 'vue'
import type { ButtonColorType } from '@/shared/data/buttonColorTypes'
import { twMerge } from 'tailwind-merge'

defineOptions({
  inheritAttrs: false,
})

const attrs = useAttrs()
const attrsWithoutClass = computed(() => {
  return {
    ...attrs,
    class: undefined,
  }
})

const props = withDefaults(
  defineProps<{
    color?: ButtonColorType
    size?: 'regular' | 'small' | 'large' | 'xs'
    isDisabled?: boolean
    isBlock?: boolean
    href?: string
    isInertiaLink?: boolean
    isRounded?: boolean
  }>(),
  {
    color: 'secondary',
    size: 'regular',
    isDisabled: false,
    isBlock: false,
    href: '',
    isInertiaLink: false,
    isRounded: true,
  },
)

const sizes = {
  xs: 'text-[11px] py-1 px-2',
  small: 'px-4 py-2 text-[13px]',
  regular: 'px-4 py-2 text-sm',
  large: 'py-3 px-6 text-base',
}

const componentName = computed(() => {
  if (props.isDisabled) return 'button'
  if (props.href) return props.isInertiaLink ? 'InertiaLink' : 'a'
  return 'button'
})
</script>
